export interface MultireportCategoryResultContract {
  category_uuid: string;
  test_results: {
    evaluation_code: number | null;
    finished_at: string;
    test_uuid: string;
  }[];
}
